import React from 'react';
import SnowLevelChart from './SnowLevelChart';
import Typography from '@mui/material/Typography';
import { Stack, Box } from '@mui/material';
import WeatherChart from './WeatherChart';
import { useForecast } from '../hooks/forecast';
import { useLocation } from '../hooks/location';
import { HighlightedAxisProvider } from './HighlightedAxisContext';
import { ChartsReferenceLine } from '@mui/x-charts/ChartsReferenceLine';
import { useObservations } from '../hooks/observations';
import PrecipChart from './PrecipChart';
import WindChart from './WindChart';

export default function DetailPage({ locationName }) {
  const location = useLocation(locationName);
  const forecast = useForecast(location);
  const observations = useObservations(location);

  console.log('Observations:', observations.data);

  if (!forecast.isLoading && !forecast.isError) {
    return (
      <Stack direction="column" pt={2}>
        <Box pl={2} pb={1.5}>
          <Typography variant="h5">{location.name}</Typography>
        </Box>

        <HighlightedAxisProvider>
          <SnowLevelChart
            forecast={forecast}
            location={location}
            xAxisPosition="top"
            showWind={false}
          />

          <WeatherChart
            forecast={forecast}
            left={{
              quantity: 'temperature',
              label: 'Temperature',
              color: '#12436D',
              valueFormatter: (temp) => `${temp} °F`,
            }}
            underlay={
              <ChartsReferenceLine
                y={32}
                lineStyle={{ strokeDasharray: '5 5' }}
                axisId="left"
              />
            }
            xAxisPosition="none"
          />

          <WindChart forecast={forecast} xAxisPosition="none" />

          <WeatherChart
            forecast={forecast}
            left={{
              quantity: 'skyCover',
              label: 'Sky Cover',
              color: '#46724aff',
              valueFormatter: (sc) => `${sc}%`,
            }}
            xAxisPosition="none"
          />

          <PrecipChart forecast={forecast} xAxisPosition="bottom" />
        </HighlightedAxisProvider>
      </Stack>
    );
  }
}
